module.exports = global["jQuery"] = require("-!/var/lib/jenkins/workspace/生产-pms前端/node_modules/_expose-loader@0.7.5@expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./~/_expose-loader@0.7.5@expose-loader?jQuery!./~/_expose-loader@0.7.5@expose-loader?$!./~/_jquery@3.6.0@jquery/dist/jquery.js-exposed
// module id = 167
// module chunks = 64